export * from './webStorage';
export * from './localStorage';
export * from './sessionStorage';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-webstorage/dist/services/index.js
// module id = ./node_modules/ngx-webstorage/dist/services/index.js
// module chunks = vendor